// Configuration for the announcement banner
// Look at src/config/announcement.js for the announcement banner config


// Predefined style themes
const ANNOUNCEMENT_STYLES = {
    red: {
        backgroundColor: '#EF4444',
        gradient: {
            from: '#EF4444',  // vivid red
            to: '#B91C1C',    // dark crimson
            deg: 45
        }
    },
    green: {
        backgroundColor: '#38B000',
        gradient: {
            from: '#38B000',  // fresh green
            to: '#1F7300',    // darker deep green
            deg: 45
        }
    },
    orange: {
        backgroundColor: '#FFA500',
        gradient: {
            from: '#FD7E14',  // bright orange
            to: '#FF8C00',    // dark orange
            deg: 45
        }
    }
};

export const ANNOUNCEMENT_CONFIG = {
    // The message to display in the announcement
    message: "🎉 Welcome to NUSWap! We're excited to have you here!",

    // Styling configuration
    style: {
        ...ANNOUNCEMENT_STYLES.orange,  // Use 'red', 'green', or 'orange'

        // Text styling
        textColor: 'white',
        fontSize: '15px',
        fontWeight: 500
    },

    // How long to wait before showing the announcement again (in milliseconds)
    reappearDelay: 300000, // 30 seconds

    // Whether the announcement is enabled
    enabled: true,

    // Optional link in the announcement
    link: {
        text: "Learn more",
        url: "/journey",
        enabled: false,
        style: {
            color: '#FFD700', // Gold color for the link
            fontWeight: 600
        }
    }
};